import { Inject, Injectable } from '@angular/core';
import {CRUD_FILE_ENDPOINT, CRUD_FORM__QUERY_SERVICE_INSTANCE} from '../survey.config';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from '../../../../core/services/snackbar-psa.service';  // Import MatSnackBar
import { QueryService } from 'src/app/core/services/query.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { SurveySaveForm } from '../models/crud-survey.model';
import { FileSurvey } from '../models/file-survey.model';
import { Subject } from 'rxjs';
import { CrudFluxService } from 'src/app/core/services/crud-flux.service';
import { ApiFluxService } from 'src/app/core/services/api-flux.service';


@Injectable({
  providedIn: 'root'
})
export class SurveyCrudFileFluxService extends CrudFluxService<FileSurvey> {

  constructor(
    @Inject(CRUD_FORM__QUERY_SERVICE_INSTANCE) public readonly query: QueryService<FileSurvey>,
    public readonly apiService:ApiFluxService,
    protected  override readonly snackbar : SnackbarService
    //@Inject(SnackbarService) protected override readonly snackbar: SnackbarService

  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(CRUD_FILE_ENDPOINT, apiService, snackbar);
  }

/*  get<SurveySaveForm>(id:string, tipoForm:string){
  return this.apiService.get<SurveySaveForm>(`${CRUD_FORM_ENDPOINT}?id=${id}&tipoForm=${tipoForm}`)
  }

  getFormData<SurveySaveForm>(idPsa:string, tipoForm:string){
    return this.apiService.get<SurveySaveForm>(`${GET_DATA_FORM_ENDPOINT}?idPsa=${idPsa}&tipoForm=${tipoForm}`, 0, true)
  } */

  get<FileSurvey>(idForm:string,tipoForm:string, name:string){
    return this.apiService.get<FileSurvey>(`${CRUD_FILE_ENDPOINT}?idForm=${idForm}&tipoForm=${tipoForm}&name=${name}`)
  }

  saveFile<FileSurvey>(dati:FileSurvey){
    let saved: Subject<any> = new Subject<any>();
    this.apiService.post<SurveySaveForm>(`${CRUD_FILE_ENDPOINT}`, dati, 0 , false).subscribe({
      next: value => saved.next(value),
      error: err => saved.error(err),
      complete: () => saved.complete(),
      
    });

    return saved.asObservable();
  }
}
